import workflowImage from 'v1/assets/icons/ga/free-trial/workflow-image.webp'
import cyedImage from 'v1/assets/icons/ga/free-trial/cyed-image.webp'
import bscImage from 'v1/assets/icons/ga/free-trial/bsc-image.webp'
import swcImage from 'v1/assets/icons/ga/free-trial/swc-image.webp'
import iwesImage from 'v1/assets/icons/ga/free-trial/ies-image.webp'
import eeBotImage from 'v1/assets/icons/ga/free-trial/ee-bot-image.webp'

import ZenHrIcon from 'v1/assets/icons/home-page/Zen HR.svg'
import ZenItIcon from 'v1/assets/icons/home-page/Zen IT.svg'
import ZenExIcon from 'v1/assets/icons/home-page/Zen EX.svg'

import folImage from 'v1/assets/icons/ga/free-trial/fol-image.webp'
import fHRlImage from 'v1/assets/icons/ga/free-trial/fhrl-image.webp'
import fITlImage from 'v1/assets/icons/ga/free-trial/fitl-image.webp'

import Icon2 from 'v1/assets/icons/ga/user-flash-with-bg.svg'
import Icon3 from 'v1/assets/icons/ga/shield-check-with-bg.svg'
import Icon4 from 'v1/assets/icons/ga/rocket-with-bg.svg'

import DLMImage from 'v1/assets/icons/ga/free-trial/dlm-image.webp'
import itSupportImage from 'v1/assets/icons/ga/free-trial/it-support-image.webp'
import globalPayrollImage from 'v1/assets/icons/ga/free-trial/global-payroll-image.webp'
import hrHelpdeskImage from 'v1/assets/icons/ga/free-trial/hr-helpdesk-image.webp'
import EORImage from 'v1/assets/icons/ga/free-trial/eor-image.webp'

export const whyZenadminWhyNowData = {
  title: 'Why ZenAdmin, Why Now?',
  slides: [
    {
      btnDetails: {
        title: 'Streamline HR & IT Operations',
        desc: 'Reduce manual tasks with automated onboarding, offboarding, and access management workflows, giving you back valuable time.',
      },
      slideDetails: {
        img: {
          src: workflowImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'Centralize Your Employee Data',
        desc: 'Manage payroll, leave, expenses, and more in a single, unified platform—improving data accuracy and efficiency.',
      },
      slideDetails: {
        img: {
          src: cyedImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'Boost Security & Compliance',
        desc: 'Automate device management, SaaS provisioning, and employee lifecycle tasks with ZenIT, ensuring a secure and compliant organization.',
      },
      slideDetails: {
        img: {
          src: bscImage,
          height: 640,
          width: 840,
        },
      },
    },
    // {
    //   btnDetails: {
    //     title: 'Scale Without Complexity',
    //     desc: 'Whether you’re managing a small team or scaling globally, ZenAdmin offers seamless integration and management across your organization.',
    //   },
    //   slideDetails: {
    //     img: {
    //       src: swcImage,
    //       height: 640,
    //       width: 840,
    //     },
    //   },
    // },
    {
      btnDetails: {
        title: 'Integrate with Existing Systems',
        desc: 'Natively integrate with over *130+ popular SaaS tools* to drive operational efficiencies across HR, IT, and Operations.',
      },
      slideDetails: {
        img: {
          src: iwesImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'Employee Experience Bot',
        desc: 'An employee-friendly bot available on Slack and MS Teams to handle day-to-day needs, such as downloading payslips, clocking in/out, requesting access to apps, and applying for leaves, ensuring a seamless and user-friendly experience.',
      },
      slideDetails: {
        img: {
          src: eeBotImage,
          height: 640,
          width: 840,
        },
      },
    },
  ],
}

export const freeTrialProducts = {
  title: 'What’s Included in the Free Trial?',
  subTitle: 'For 30 days, you’ll have full access to',
  list: [
    {
      icon: ZenHrIcon,
      title: 'Zen HR',
      bgClass: 'bgW10',
      borderClass: 'borderW50',
      text: 'Automate core HR functions—onboarding, time & attendance, employee records, and performance management—all in one place.',
    },
    {
      icon: ZenItIcon,
      title: 'Zen IT',
      bgClass: 'bgG10',
      borderClass: 'borderG50',
      text: 'Simplify IT operations with automated workflows, identity and access management, app provisioning, and device management to ensure a secure and compliant posture.',
    },
    {
      icon: ZenExIcon,
      title: 'Zen Tools',
      bgClass: 'bgI10',
      borderClass: 'borderI50',
      text: 'Streamline operational processes with our powerful suite of tools designed for HR and IT teams.',
    },
  ],
}

export const whyZenadmin = {
  headingData: {
    title: 'Crafted for Leaders like You',
  },
  tabs: [
    {
      key: 'fol',
      title: 'For Operational Leaders',
      btnTitle: 'For Operational Leaders',
      paragraph:
        'Unlock operational efficiencies by automating repetitive processes across HR and IT. Gain valuable time back, focus on scaling your business, and ensure compliance and security at every step.',
      quotes: 'ZenAdmin has helped us save 40 hours per week in manual HR and IT processes.',
      author: '~ Michael, Operations Director, TechCo',
      image: folImage,
    },
    {
      key: 'fhrl',
      title: 'For HR Leaders',
      btnTitle: 'For HR Leaders',
      paragraph:
        'Automate manual people operations, reduce errors, and improve employee experiences. From onboarding to performance management to our employee experience bot, *ZenHR* has you covered.',
      quotes:
        'Since adopting ZenAdmin, our employee onboarding time has been cut by 60%, day 1 readiness of our employees is at 100%, and our HR data is more accurate than ever.',
      author: '~ Sarah, CHRO, Global Ventures',
      image: fHRlImage,
    },
    {
      key: 'fitl',
      title: 'For IT Leaders',
      btnTitle: 'For IT Leaders',
      paragraph:
        'Gain control over asset management, automate provisioning, and ensure security at every step. *ZenIT* helps you save time while maintaining compliance—across *150+ countries*.',
      quotes:
        'ZenIT has completely transformed our asset management. We’ve streamlined processes across 14 countries and improved compliance by 90% through ZenIT’s native integration with MDM.',
      author: '~ David, IT Director, FinTechCorp',
      image: fITlImage,
    },
  ],
}

export const topBenefitsData = {
  title: 'Proven Cost Savings',
  list: [
    {
      icon: Icon2,
      title: 'Up to 80% reduction',
      text: 'in operational costs for HR and IT functions.',
    },
    {
      icon: Icon4,
      title: '75% faster onboarding',
      text: 'processes, cutting employee downtime.',
    },
    {
      icon: Icon3,
      title: '50% reduction',
      text: 'in manual errors and improved compliance rates.',
    },
  ],
}

export const operationalSupportData = {
  title: 'Service Add-ons for Full Operational Support',
  desc: 'Enhance your ZenAdmin experience with our powerful service add-ons:',
  slides: [
    {
      btnDetails: {
        title: 'Device Lifecycle Management (DLM)',
        desc: 'Manage devices from procurement to dispatch, retrieval, and disposal across 150+ countries.',
      },
      slideDetails: {
        img: {
          src: DLMImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'IT Support',
        desc: '24/7/365 IT support for all your teams globally, with a guaranteed *15-minute SLA* for response time.',
      },
      slideDetails: {
        img: {
          src: itSupportImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'Global Payroll',
        desc: 'Seamless, end-to-end payroll as a service for your entire workforce, ensuring compliance and accuracy.',
      },
      slideDetails: {
        img: {
          src: globalPayrollImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'HR Helpdesk',
        desc: 'Give your employees the support they need with our *AI-powered HR concierge* service.',
      },
      slideDetails: {
        img: {
          src: hrHelpdeskImage,
          height: 640,
          width: 840,
        },
      },
    },
    {
      btnDetails: {
        title: 'Employer of Record (EOR)',
        desc: 'Hire and pay global employees without the complexity of managing multiple international entities—*ZenAdmin* makes it easy to scale.',
      },
      slideDetails: {
        img: {
          src: EORImage,
          height: 640,
          width: 840,
        },
      },
    },
  ],
}
